module.exports = __webpack_public_path__ + "media/images/badge/giorno-da-leoni_secondary-4de3ad2dda26ce09a3187c40a6e4c37c.png";